import { AuthApi } from './types';

const base = '/auth';

export const authApi: Readonly<AuthApi> = {
  token: (filters) => `${base}/token${filters}`,
  refreshToken: (filters) => `${base}/refresh_token${filters}`,
  roles: (filters) => `${base}/roles/${filters}`,
  statusControl: (filters) => `${base}/status/all/${filters}`,
};
